import { FORM_MODES } from 'config/formModes';
import { ENTITY, PUSH_API_ROUTE_PATH } from '../config';
import { generatePushApiReportFormPath } from '../services/generatePushApiReportFormPath';

export const generatePushApiReportsCreatorPath = () =>
    generatePushApiReportFormPath(PUSH_API_ROUTE_PATH, {
        entity: ENTITY.PUSH_API,
        mode: FORM_MODES.CREATE,
    });

export const generatePushApiReportsEditPath = (accountId, subscriptionId) =>
    generatePushApiReportFormPath(PUSH_API_ROUTE_PATH, {
        entity: ENTITY.PUSH_API,
        mode: FORM_MODES.EDIT,
        accountId,
        subscriptionId,
    });
